/* eslint-disable prefer-template */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { FormHelperText, IconButton, TextField, Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';





const EditEntityDataGrid = ({ gridData, handleEdit, handleDelete, formValueArr, SetentitySetData, handleDeleteAllDocument }) => {

    const [rows, setRows] = useState([]);


    useEffect(() => {

        SetentitySetData(() => formValueArr);
    }, [rows])


    useEffect(() => { // NOSONAR
        if (gridData?.length > 0) {
            const transformedRows = gridData.map((data) => {
                const {
                    EntityId,
                    SchemeId = [],
                    ClaimId = [],
                    DistributorId = [],
                    DocumentTypeId,
                    CourierNumber,
                    CourierDate,
                    ReceivedDate,
                    SAPDocumentNumber,
                    CNDate,
                    AgreementNumber,
                    AgreementDate,
                    UploadFile = [],
                } = data;

                return {
                    entity: EntityId ? `Entity: ${EntityId.Entity || "N/A"}` : "N/A",
                    levelDetails: [
                        DistributorId && DistributorId.filter(Boolean).length > 0
                            ? `Distributor: ${DistributorId.filter(Boolean)
                                .map((dist) => dist?.Distributor)
                                .filter(Boolean)
                                .join(", ")}`
                            : null,
                        SchemeId && SchemeId.filter(Boolean).length > 0
                            ? `SchemeName: ${SchemeId.filter(Boolean)
                                .map((scheme) => scheme?.Name)
                                .filter(Boolean)
                                .join(", ")}`
                            : null,
                        ClaimId && ClaimId.filter(Boolean).length > 0
                            ? `Claim: ${ClaimId.filter(Boolean)
                                .map((claim) => claim?.EntityName)
                                .filter(Boolean)
                                .join(", ")}`
                            : null,
                    ]
                        .filter(Boolean)
                        .join("\n"),
                    documentType: DocumentTypeId ? `DocumentType: ${DocumentTypeId.DocumentType || "N/A"}` : "N/A",
                    documentTypeDetails: [
                        CNDate ? `CNDate: ${CNDate}` : null,
                        ReceivedDate ? `ReceivedDate: ${ReceivedDate}` : null,
                        CourierDate ? `CourierDate: ${CourierDate}` : null,
                        SAPDocumentNumber ? `SAPDocumentNumber: ${SAPDocumentNumber}` : null,
                        AgreementNumber ? `AgreementNumber: ${AgreementNumber}` : null,
                        AgreementDate ? `AgreementDate: ${AgreementDate}` : null,
                        UploadFile != null && UploadFile.length > 0
                            ? `UploadFile: ${UploadFile.map((file, index) =>
                                file?.isDummy
                                    ? file?.name?.replace(/^\d+_/, '')
                                    : file?.name || ""
                            ).join(", ")}`
                            : "N/A",
                        CourierNumber ? `CourierNumber: ${CourierNumber}` : null,
                    ]
                        .filter(Boolean)
                        .join("\n"),
                };
            });

            const rowsWithIds = transformedRows.map((row, index) => ({ ...row, id: index }));

            setRows(rowsWithIds);
        } else {
            setRows([]);
        }
    }, [gridData]);





    const [columns] = useState([
        {
            field: 'entity',
            headerName: 'Entity',
            flex: 0.6,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {params.value.split('\n').map((line, index) => {
                        const [value] = line.split(':');
                        return (
                            <div key={index}> { /* NOSONAR: Index as key is acceptable due to non-reordering static list */ }
                                {value}
                            </div>
                        );
                    })}
                </div>
            ),
        },
        {
            field: 'levelDetails',
            headerName: 'Level Details',
            flex: 2,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {params.value.split('\n').map((line, index) => {
                        const [key, value] = line.split(':');
                        return (
                            <div key={index}> { /* NOSONAR: Index as key is acceptable due to non-reordering static list */ } 
                                <strong>{key}:</strong> {value}
                            </div>
                        );
                    })}
                </div>
            ),
        },
        {
            field: 'documentType',
            headerName: 'Document Type',
            flex: 1,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {params.value.split('\n').map((line, index) => {
                        const [value] = line.split(':');
                        return (
                            <div key={index}> { /* NOSONAR: Index as key is acceptable due to non-reordering static list */ }
                                {value}
                            </div>
                        );
                    })}
                </div>
            ),
        },
        {
            field: 'documentTypeDetails',
            headerName: 'Document Type Details',
            flex: 1.5,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'pre-wrap' }}>
                    {params.value.split('\n').map((line, index) => {
                        const [key, value] = line.split(':');
                        return (
                            <div key={index}> { /* NOSONAR: Index as key is acceptable due to non-reordering static list */ }
                                <strong>{key}:</strong> {value}
                            </div>
                        );
                    })}
                </div>
            ),
        },
        {
            field: 'edit',
            headerName: 'Edit',
            sortable: false,
            renderCell: (params) => (
                <IconButton sx={{ padding: 0 }} onClick={() => handleEdit(params.row.id)} >
                    <Iconify
                        icon="material-symbols:edit-outline"
                        width="15px"
                        height="15px"
                        color="primary.main"
                        sx={{ padding: 0 }}
                    />
                </IconButton>
            ),
            width: 40,
        },
        {
            field: 'delete',
            headerName: 'Delete',
            sortable: false,
            renderHeader: () => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        onClick={handleDeleteAllDocument} title="Delete All"
                        sx={{ display: 'flex', alignItems: 'center', marginLeft: '0px', paddingLeft: 0 }}
                    >
                        <Iconify icon="fluent:delete-32-regular" width='15px' height='15px' color="red" />
                    </IconButton>
                    <span>Delete</span>
                </div>
            ),
            renderCell: (params) => (
                <IconButton sx={{ padding: 0 }} onClick={() => handleDelete(params.row.id)} >
                    <Iconify icon="fluent:delete-32-regular" width="15px" height="15px" color="red" sx={{ padding: 0 }} />
                </IconButton>

            ),
            width: 80,
        },
    ]);

    const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
        [`& .${gridClasses.columnHeader}`]: {
            backgroundColor: 'white',
            color: 'black',
            fontWeight: 'bold',
            fontSize: '14px',
            height: '40px',  // Reduce header height
            lineHeight: '40px',  // Adjust line height to match
            paddingLeft: '4px', // Remove left padding
        },

        '& .MuiDataGrid-cell': {
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.3)}`,
            fontSize: '13px', // Adjust font size if needed
            padding: '4px 8px 4px 4px', // Adjust cell padding to reduce row height
            '&:hover': {
                backgroundColor: 'white',
            },
            alignItems: 'start',
        },

        '& .MuiDataGrid-row': {
            minHeight: '40px',  // Reduce row height
            maxHeight: '40px',  // Keep row height consistent
            '&:hover': {
                backgroundColor: 'white',
            },
            padding: '10px 0px'
        },

        '& .MuiDataGrid-columnSeparator': {
            display: 'none',
        },

        '& .MuiDataGrid-menuIcon': {
            display: 'none',
        },
        // Align first column cells to the right
        '& .MuiDataGrid-cell.SchemeFilterOn': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for second column
        },
        '& .MuiDataGrid-cell.Filter': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for third column
        },
        '& .MuiDataGrid-cell.FilterSubClassification': {
            textAlign: 'left',
            paddingLeft: '0px', // Remove left padding for fourth column
        },

    }));


    return (
        <div style={{
            display: true ? 'flex' : 'none',
            minHeight: 0,
            flexDirection: 'column',
            maxHeight: '100%',
            height: '100%',
        }}>
            <div style={{ flex: 1 }} >
                <style>
                    {`
                    .css-191bxd1-MuiDataGrid-columnHeaderTitle {
                        font-weight: 700;
                    }
                    .css-1vjh543-MuiDataGrid-footerContainer {
                        display: none;
                    }
                    .MuiDataGrid-footerContainer css-1vjh543-MuiDataGrid-footerContainer{
                        display: none;
                    }
                    .css-119y528-MuiDataGrid-root .MuiDataGrid-row{
                        padding-bottom: 0px;
                    }
                `}
                </style>



                <div style={{ boxSizing: 'border-box', height: '100%', overflow: 'auto' }}>
                    <StripedDataGrid  localeText={{ noRowsLabel: 'Data not found' }}
                        rows={rows}
                        size='small'
                        columns={columns}
                        headerHeight={40}
                        getRowHeight={() => 'auto'}
                        pageSize={100}
                        disableSelectionOnClick
                        // experimentalFeatures={{ newEditingApi: true }}
                        getRowId={(row) => row.id} // Assuming each row has a unique 'id'
                        sx={{
                            height: '100%',
                            overflowY: 'auto', // Enable vertical scrolling for content
                            '& .odd': {
                                backgroundColor: 'background.default',
                            },
                            '& .even': {
                                backgroundColor: 'action.hover',
                            },
                        }}
                        components={{
                            Pagination: null,
                        }}
                        getRowClassName={(params) =>
                            params.indexRelativeToCurrentPage % 2 === 0 ? 'odd' : 'even'
                        }
                    />
                </div>
            </div>
        </div>
    );

}

export default EditEntityDataGrid;